import { S as o } from "./segmentControl-ba90067e.mjs";
import "react/jsx-runtime";
import "react";
import "./index-6a632112.mjs";
import "./themes-5f0b3c3d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
import "./useWindowDimensions.js";
const g = o;
export {
  g as SegmentControl
};
